import { useEffect } from "react";
import { STORE } from "@/lib/constants";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, path = "" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${STORE.name}` : `${STORE.name} — ${STORE.tagline}`;
    document.title = fullTitle;
    const desc =
      description ||
      "BigBerry Store — reseller gadget premium bergaransi resmi & brand new. Apple, Samsung, Google, GoPro, JBL, Bose & lainnya. Bisa cicilan/BNPL. Beli via WhatsApp.";
    const canonical = `${STORE.url}${path}`;

    upsertMeta("name", "description", desc);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:image", `${STORE.url}/assets/og-image.png`);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", desc);
    upsertMeta("name", "twitter:image", `${STORE.url}/assets/og-image.png`);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }, [title, description, path]);

  return null;
}
